import styles from "./Attributes.module.css";

export const Attributes = ({
  attributes,
}: {
  attributes: { name: string; value: string; id: number | string }[];
}) => {
  return (
    <div className={styles.attributesContainer}>
      {attributes.map((attr, index) => (
        <div className={styles.attribute} key={`${attr}${index}`}>
          <span>{attr.name}: </span>
          <strong>{attr.value}</strong>
        </div>
      ))}
    </div>
  );
};
